import React, {Component} from 'react';

import {slugify} from '../../../utilities/string';

const jQuery = window.jQuery,
	$ = jQuery;

class PortfolioItem extends Component {

	componentDidMount() {
		$(".popup-link").magnificPopup({
			type: 'inline'
		});
	}

	render() {
		const {translate, title, image, filters, description, hidden = false, className = "mix col l4 m4 s12"} = this.props;
		return hidden ? null : (
			<div className={filters.concat([className]).join(' ')}>
				<div className="single-portfolio">
					<img className="responsive-img" src={image} alt={translate(title)}/>
					<div className="overlay">
						<a href={`#portfolio-modal-${slugify(translate(title))}`} className="popup-link expand">
							<i className="mdi mdi-plus-circle"/>
						</a>
					</div>
					<div id={`portfolio-modal-${slugify(translate(title))}`} className="white-popup mfp-hide">
						<div className="popup-content">
							<img className="responsive-img" src={image} alt={translate(title)}/>
							<div className="popup-details">
								<h4>{translate(title)}</h4>
								<p>{translate(description)}</p>
							</div>
						</div>
					</div>
					<a className="close-overlay hidden">x</a>
				</div>
			</div>
		);
	}
}

export default PortfolioItem;



// WEBPACK FOOTER //
// ./src/components/elements/Portfolio/PortfolioItem.js